





















import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  // eslint-disable-next-line no-unused-vars
  setup(_, { emit }) {
    const fileSelector = ref<HTMLInputElement>(null)

    const fireFileSelectedEvent = (file: File) => emit('file-selected', file)

    const fileSelected = event => {
      fireFileSelectedEvent(event.target.files[0])
    }

    const dropFile = event => {
      if (event.dataTransfer.items) {
        if (event.dataTransfer.items[0].kind === 'file') {
          fireFileSelectedEvent(event.dataTransfer.items[0].getAsFile())
        }
      } else {
        if (event.dataTransfer.files.length > 0) {
          fireFileSelectedEvent(event.dataTransfer.files[0])
        }
      }
    }

    const selectFile = () => fileSelector.value.click()

    return {
      selectFile,
      dropFile,
      fileSelected,
      fileSelector
    }
  }
})
